import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";

import CourseSection, {
  SectionLecture,
} from "../../../models/course-content.model";

@Component({
  selector: "ngx-preview-sections",
  styleUrls: ["./sections.component.scss"],
  templateUrl: "./sections.component.html",
})
export class PreviewCourseSectionsComponent implements OnInit {
  @ViewChild("item", { static: true }) accordion;
  @Output() onOpenSourceContent: EventEmitter<any> = new EventEmitter();
  @Output() onEnrollCourse: EventEmitter<any> = new EventEmitter();

  @Input() courseId = "";
  @Input() lectureContentId = "";
  @Input() sourceType = "";
  @Input() sections?: CourseSection[];
  sectionId = "";

  loading = false;

  constructor() {}

  ngOnInit() {}

  openSourceContent(item: SectionLecture) {
    this.sourceType = item.sourceType;
    this.lectureContentId = item.lectureContentId;
    this.onOpenSourceContent.emit(item);
  }

  enrollCourse() {
    this.onEnrollCourse.emit();
  }
}
